import API from '../api/index';
import ILog from '../types/Log';

// Los sitios que registran errores pasan `e.response` (la respuesta de axios), que incluye la configuración de la petición y
// con ella la cabecera Authorization (el token de sesión). Aquí, único punto de salida, se queda solo lo útil.
const CLAVES_SENSIBLES = ['config', 'headers', 'request', 'authorization', 'token', 'password', 'pass', 'jwt', 'cookie'];

const reducirMeta = (meta: unknown): unknown => {
    if (meta === null || typeof meta !== 'object') return meta;
    const origen = meta as Record<string, unknown>;
    // Respuesta de axios: solo el código y lo que respondió el servidor
    if ('status' in origen && 'data' in origen) return { status: origen.status, data: origen.data };
    return Object.fromEntries(Object.entries(origen).filter(([clave]) => !CLAVES_SENSIBLES.includes(clave.toLowerCase())));
};

const logError = (data: ILog) => API.post('logerror', { ...data, meta: reducirMeta(data.meta) });

const LogService = {
    logError
};

export default LogService;